import React, {useEffect, useState } from 'react';
import Select from 'react-select';

const webURL = window.location.host.indexOf('localhost') >= 0 ? 'http://localhost:3001' : 'https://dev-ogr.golfez.in';

const BookUserTable = (props) => {
    const {
        settlementList,
        isHoliday,
        bookSheet,        
        selectedDate,
        selectedCompany,
        teeTimeGroupID, 
        setTeeTimeGroupID,
        bookingUsers, 
        rateDetails,
        calculateGreenFee,
        companyList,
        setSelectedCompany,
        updateBookingDetails,
        cancelBookingHandler,
        isActionAllowed,
        setShowCompany
        // expandedGroups,
    } = props; 

    const [groupedUserList, setGroupedUserList] = useState([]);
    const [expandedGroups, setExpandedGroups] = useState({});

    useEffect(()=>{
        if(bookingUsers.length == 0) return setGroupedUserList([]);

        const newlist = bookingUsers.reduce((acc, user) => {
            const teeTimeBookID = String(user.TeeTimeBookID || 0);
            if (!acc[teeTimeBookID]) {
                acc[teeTimeBookID] = [];
            }
            acc[teeTimeBookID].push(user);
            return acc;
        }, {})

        // console.log('newlist', newlist)

        setGroupedUserList(newlist);
    },[bookingUsers]);   

    //#region Handlers

        //Removes Playes from the User Table -
        const deleteUserHandler = (index) => {
            //Can Remove Only Newly Added USER
            const updatedList = bookingUsers.filter((f, i) => (i !== index));
            const newUsers    = updatedList.filter(t => t.TeeTimeBookID == 0);            
            
            /** @todo - REMOVE SetTimeout if Not needed Trigger green fee calculation after deletion */
            setTimeout(() => {
                calculateGreenFee(
                    bookSheet.Hole,
                    selectedDate,
                    newUsers,
                    teeTimeGroupID,
                    isHoliday,
                    (bookSheet?.RelatedBookings?.find(f => f?.ID == teeTimeGroupID)?.Discount || 0),
                    updatedList,  //Pass Values
                    'removeUser',
                    bookSheet.TemplateID,
                );
            }, 100);    
            
            // if(updatedList.length == 0) setExpandedGroups({});
        };

        // Function to toggle expansion of payment details for a specific group
        const toggleGroupExpansion = (teeTimeBookID, companyID) => {
            if(companyID != 0){
                //    console.log('companyList', companyList)
                const companyD = companyList.find(f => f.ID == companyID)
                setSelectedCompany(companyD)          
            }
            
            setExpandedGroups((prev) => {
                if (prev[teeTimeBookID]) {
                    setTeeTimeGroupID(0); // Updates state asynchronously
                    return { ...prev, [teeTimeBookID]: false };
                }
                
                const allClosed = {};
                Object.keys(prev).forEach((key) => (allClosed[key] = false));
                setTeeTimeGroupID(teeTimeBookID); // Updates state asynchronously
        
                return { ...allClosed, [teeTimeBookID]: true };
            });
        };

        // Get related booking by TeeTimeBookID
        const getRelatedBooking = (teeTimeBookID) => {
            return bookSheet.RelatedBookings.find(booking => booking.ID === teeTimeBookID) || {
                Comment: "",
                Discount: 0,
                PaymentMode: "",
                CompanyID: 0
            };
        }; 

        // Handler for the cart checkbox change
        const handleCartChange = (userId, teeTimeBookID, index, isChecked) => {
            // Update the bookingUserList
            const updatedBookingUserList = bookingUsers.map(user => {
                if (user.ID === userId) {
                    return {
                        ...user,
                        IsCartRequired: isChecked ? 'Y' : 'N',
                        IsCaddyRequired: isChecked ? 'Y' : 'N', // Set caddy to match cart status
                        IsCartUpdated: true // Track that this was manually updated
                    };
                }
                return user;
            });
            
            // Update the state -- Calculate Green Fee Does this
            // setBookingUserList(updatedBookingUserList);
            
            // Group the updated list to reflect changes
            const updatedGroupedUsers = updatedBookingUserList.reduce((acc, user) => {
                const userTeeTimeBookID = user.TeeTimeBookID || 0;
                if (!acc[userTeeTimeBookID]) {
                    acc[userTeeTimeBookID] = [];
                }
                acc[userTeeTimeBookID].push(user);
                return acc;
            }, {});
            
            // Get the specific group of users for this teeTimeBookID
            const groupUsers = updatedGroupedUsers[teeTimeBookID] || [];
            
            // Find the related booking to get the discount value
            const relatedBooking = getRelatedBooking(parseInt(teeTimeBookID));
            
            // Call calculateGreenFee with the updated data
            calculateGreenFee(
                bookSheet.Hole,
                selectedDate,
                groupUsers,
                teeTimeBookID,
                isHoliday,
                relatedBooking.Discount || 0,
                bookingUsers,
                'Cart Toggle',
                bookSheet.TemplateID,
            );
        };

        const viewForm = (transactionId) => {
            if (!transactionId) {
                return swal.fire({
                    icon      : 'error',
                    titleText : "Transaction ID missing"
                });
            }
            // window.open(`http://localhost:3001/invoice?id=${transactionId}`, '_blank', 'noopener');
            window.open(`${webURL}/invoice?id=${transactionId}`, '_blank', 'noopener');
        };
    //#endregion

    return (
        <div>
            {/* Render each group separately */}
            {Object.keys(groupedUserList).map((teeTimeBookID, i) => {         
                const users = groupedUserList[teeTimeBookID];
                const relatedBooking = getRelatedBooking(parseInt(teeTimeBookID));   
                             
                const isExpanded  = expandedGroups[teeTimeBookID] || false;
                const currentRate = rateDetails.get(Number(teeTimeBookID));

                return (
                    <div key={`group-${teeTimeBookID}`} className="mb-4">
                        {/* Group Header - optional */}
                        <div className="group-header mb-2">
                            <h4>{teeTimeBookID == 0 ? "New" : ((Object.keys(relatedBooking).length && teeTimeBookID == 0 ) > 0 ? i + "st Booking" : '') } </h4>
                        </div>
                        
                        {/* Users Table */}
                        <div className="group" style={{width: '100%'}}>
                            <table id={`table-user-${teeTimeBookID}`} className="table table-bordered table-hover" style={{marginBottom: '-14px'}}>
                                <thead className="light-grey-background">
                                    <tr>
                                        <th>Players</th>
                                        <th>Category</th>
                                        <th>Cart</th>
                                        <th className="text-center">Action</th>
                                    </tr>
                                </thead>
                                {users && users.length > 0 &&
                                    <tbody>                                    
                                        {users.map((m, i) => (                                           
                                            <tr key={i}>
                                                <td>
                                                    <span className={`kt-badge kt-badge--${m.UserType == "User" ? 'success' : ( m.UserType == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot`}></span>
                                                    &nbsp; &nbsp;{m.Name || m.UserName} <br/>
                                                    &nbsp; &nbsp;
                                                    <small style={{color: "Red"}}>{( m.IsMembershipExpires == "N" || m.IsSubscriptionExpires == "N" ) ? "Subscription Expired!" : ''}</small>                                                   
                                                </td>
                                                <td>
                                                    {m.SubCategoryName}
                                                </td>
                                                
                                                <td className="padding-0">
                                                    <span className="kt-switch kt-switch--sm kt-switch--icon padding-l5">
                                                        <label className="margin-b0">
                                                        <input 
                                                            id={`chkCart-${teeTimeBookID}-${i}`} 
                                                            name={`chkCart-${teeTimeBookID}-${i}`}
                                                            type="checkbox" 
                                                            disabled={m?.isToggleDisabled || m.UserType == "Guest" || m.UserType == "UsersGuest" || relatedBooking.ID != 0 ? true : false}
                                                            checked={m.IsCartRequired !== 'N'}
                                                            onChange={(e) => handleCartChange(m.ID, teeTimeBookID, i, e.target.checked)}
                                                        />
                                                        <span></span>
                                                        </label>
                                                    </span>
                                                </td>
                                                <td>
                                                    {teeTimeBookID == 0 && (
                                                        (users.length == 1 && i == 0) || 
                                                        (users.length > 1 && i > 0)
                                                    ) && (
                                                        <center>
                                                            <button 
                                                                className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs margin-r10 btn-user-delete"
                                                                type="button"
                                                                onClick={() => deleteUserHandler(bookingUsers.findIndex(u => u.ID === m.ID), m)}
                                                            >
                                                                <i className="flaticon2-rubbish-bin-delete-button"></i>
                                                            </button>
                                                        </center>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                        
                                    </tbody>
                                }
                            </table>

                            {/* Payment Details Section for this group */}
                            {users && users.length > 0 ? (
                                <div className="card mt-3">
                                    <div className={`card-header d-flex justify-content-between align-items-center cursor-pointer ${isExpanded ? 'active-header bg-light' : ''}`} id={`paymentDetailsHeader-${teeTimeBookID}`}
                                        onClick={() => {toggleGroupExpansion(teeTimeBookID, relatedBooking.CompanyID)}} 
                                        aria-expanded={isExpanded}
                                    >
                                        <div style={{ flex: 1, textAlign: "center", fontWeight: "bold", color: isExpanded ? '#5d78ff' : 'inherit' }}>
                                            Payment Details
                                        </div>
                                        <div className="card-title margin-b0">
                                            <i className="fa fa-chevron-right" 
                                            style={{ 
                                                transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)', 
                                                transition: 'transform 0.3s',
                                                color: isExpanded ? '#5d78ff' : 'inherit'
                                            }}>
                                            </i>
                                        </div>
                                    </div>
                                    <div id={`paymentDetails-${teeTimeBookID}`} className={`collapse ${isExpanded ? "show" : ""}`} aria-labelledby={`paymentDetailsHeader-${teeTimeBookID}`}>
                                        <div className="card-body">
                                            {/* Discount Section */}
                                            <div className="form-group row">
                                                <label className="col-form-label col-sm-3 text-right">Discount %</label>
                                                <div className="col-6 input-group">
                                                <input
                                                    id={`txtDiscount-${teeTimeBookID}`}
                                                    name={`txtDiscount-${teeTimeBookID}`}
                                                    type="number"
                                                    className="form-control"
                                                    disabled={teeTimeGroupID != 0}
                                                    value={relatedBooking.Discount || 0}      
                                                    onWheel={(e) => e.currentTarget.blur()}                                            
                                                    onChange={(event) => {
                                                        // Get the entered value
                                                        let value = event.target.value;                                                        
                                                        // // Enforce limits
                                                        if (value > 100) value = 100;
                                                        if (value < 0) value = 0;
                                                        
                                                        // Update the booking details with the validated value
                                                        updateBookingDetails('Discount', value, parseInt(teeTimeBookID));
                                                    }}
                                                />
                                                    <div className="input-group-append">
                                                        <span className="input-group-text">
                                                            <i className="flaticon2-percentage"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Payment Mode */}
                                            {teeTimeGroupID == 0  && (
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3 text-right">Settle Mode</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <Select
                                                            value={{label: settlementList.find(m => m.Name === relatedBooking.PaymentMode)?.Name, value: settlementList.find(m => m.Name === relatedBooking.PaymentMode)?.ID}}
                                                            onChange={(event) => updateBookingDetails('PaymentMode', event.label, parseInt(teeTimeBookID))}
                                                            name={`ddlMode-${teeTimeBookID}`}
                                                            placeholder="Select Mode"
                                                            isDisabled={teeTimeGroupID != 0? "disabled" : ''}
                                                            id={`ddlMode-${teeTimeBookID}`}
                                                            className="ddlMode"
                                                            options={settlementList.map(c => ({
                                                                label: c.Name,
                                                                value: c.ID
                                                            }))}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {/* Comment Section */}
                                            <div className="form-group row">
                                                <label className="col-form-label col-lg-3 text-right">Comment</label>
                                                <div className="col-xl-6 col-lg-8">
                                                    <textarea
                                                        id={`txtComment-${teeTimeBookID}`}
                                                        name={`txtComment-${teeTimeBookID}`}
                                                        className="form-control"
                                                        rows="3"
                                                        value={relatedBooking.Comment || ''}
                                                        onChange={(event) => updateBookingDetails('Comment', event.target.value, parseInt(teeTimeBookID))}
                                                    ></textarea>
                                                </div>
                                            </div>

                                            {/* Tax Details Table */}
                                            <table className="table table-bordered table-hover margin-b30">
                                                <thead className="light-grey-background">
                                                    <tr>
                                                        <th>Description</th>
                                                        <th className="text-right">Amount (₹)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {currentRate?.GreenFee != 0 && (
                                                        <tr>
                                                            <td>Green Fee</td>
                                                            <td className="text-right">₹ {currentRate?.GreenFee}</td>
                                                        </tr>
                                                    )}
                                                    {currentRate?.ShowCart && (
                                                        <tr>
                                                            <td>{currentRate?.NoOfCart} Cart</td>
                                                            <td className="text-right"> ₹ {currentRate?.CartFee}</td>
                                                        </tr>
                                                    )}
                                                    {currentRate?.ShowCaddy && (
                                                        <tr>
                                                            <td>{currentRate?.NoOfCaddy} Caddy</td>
                                                            <td className="text-right"> ₹ {currentRate?.CaddyFee}</td>
                                                        </tr>
                                                    )}
                                                    {currentRate?.ShowDynamicDiscount && (
                                                        <tr>
                                                            <td>
                                                                {/* Standard discount-value label -- kept identical to
                                                                    formatDynamicDiscountValueLabel in api-ogr/helpers/dynamicPricingHelper.js
                                                                    (used for the invoice), since this is a separate frontend bundle. */}
                                                                Off-Peak Hour Discount
                                                                {currentRate?.DynamicDiscountType === 1 && ` (₹${currentRate?.DynamicDiscountValue} off)`}
                                                                {currentRate?.DynamicDiscountType === 2 && ` (${currentRate?.DynamicDiscountValue}% off)`}
                                                                {currentRate?.DynamicDiscountType === 3 && ` (${currentRate?.DynamicDiscountValue}% off (capped))`}
                                                            </td>
                                                            <td className="text-right">- ₹ {currentRate?.DynamicDiscountAmount}</td>
                                                        </tr>
                                                    )}
                                                    {currentRate?.Discount != 0 && (
                                                        <tr>
                                                            <td>Admin Discount</td>
                                                            <td className="text-right">- ₹ {currentRate?.Discount}</td>
                                                        </tr>
                                                    )}
                                                    <tr>
                                                        <td>SGST (9%)</td>
                                                        <td className="text-right">₹ {currentRate?.Sgst}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>CGST (9%)</td>
                                                        <td className="text-right">₹ {currentRate?.Cgst}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>Total</strong></td>
                                                        <td className="text-right"><strong>₹ {currentRate?.Total}</strong></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div className="row margin-b20 margin-l5">
                                                <div className="col-sm-12 pl-0">
                                                    <h6 className="margin-0">
                                                        <strong id="lblOwner">
                                                            {users && users.length > 0 && users[0].UserName && 'Booked By ' + (relatedBooking.UserType == 'Admin' ? 'Admin' : users[0].UserName) }
                                                            <div className='margin-b5'></div>
                                                            {relatedBooking?.ID && users[0]?.UserName ? `Tracking ID : ${relatedBooking?.TrackingID}` : ''}
                                                        </strong>
                                                    </h6>   
                                                </div>
                                            </div>
                                            <div className="d-flex w-100 padding-t20">
                                                <span>
                                                    <span id={`lblGstNo-${teeTimeBookID}`} className="lbl text-center margin-l10" data-toggle="modal" data-target="#modalCompany" 
                                                        onClick={() => setShowCompany(users[0].ID)}
                                                    >
                                                        {selectedCompany?.ID ? `${selectedCompany.CompanyName} : ${selectedCompany.GSTNumber}` : 'Add GST Number'}
                                                    </span>
                                                </span>
                                                <div className="ml-auto">
                                                    {relatedBooking?.ID ? (<button className="btn btn-warning mr-1" onClick={(e) => {e.preventDefault(), viewForm(relatedBooking.TransactionID)}}>Invoice</button>) : ''}
                                                    {relatedBooking?.ID && isActionAllowed ? <button id="btnCancel" type="button" className="btn btn-danger d-inline-block margin-lr10" 
                                                        onClick={()=>cancelBookingHandler(teeTimeBookID)}
                                                    > Cancel Booking</button> : ''}                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="padding-b20"></div>
                            )}
                        </div>
                    </div>
                );
            })}

        </div>
    );
}

export default BookUserTable;

